/**
 * @file wizard.js
 *
 * @fileoverview Exports application wizards configurations.
 */

module.exports = {
  public: {
    RESUME: {
      FIELD_INFO: {
        personal_info: {
          key: 'personal_info',
          name: 'Enter your personal information',
          description: `Add your personal data to your profile.`,
          privateFields: {
            resume_firstname: true,
            resume_lastname: true,
            field_resume_phone: true,
            field_resume_birthday: true,
            field_resume_home_location: true,
          },
          fields: {
            field_resume_salutation: 'salutation',
            resume_firstname: 'firstName',
            resume_lastname: 'lastName',
            field_resume_birthday: 'birthday',
            field_resume_home_location: 'homeLocation',
          },
        },
        job_preferences: {
          key: 'job_preferences',
          name: 'Enter your Job preferences',
          description: `Provide the recruiters more information about your job preferences.`,
          fields: {
            field_resume_title: 'title',
            field_resume_job_pref_occupation: 'desiredOccupation',
            field_resume_employment_type: 'employmentType',
            field_resume_pref_location: 'desiredLocation',
            field_resume_pref_salary_range: 'desiredSalary',
            field_resume_career_status: 'careerStatus',
            field_resume_job_availability: 'availableStart',
            field_resume_availability_period: 'availabilityPeriods',
          },
        },
      },
      SHOW_SECTIONS: ['personal_info', 'job_preferences'],
    },
    SELF_SERVICE: {
      // Configuration for the self service checkout "order form" step. The step
      // renders whatever fields a client configures on the order form bundle in
      // the backend; this only controls optional presentation enhancements.
      ORDER_FORM: {
        // Special widgets applied to specific fields, keyed by field machine
        // name. Core ships none: the step renders every field from its
        // definition and multi-value list fields automatically use a
        // multi-select. Clients with bespoke forms map a `widget` key here and
        // resolve it to a component by overriding the FormWidgetSlot, e.g.
        //   field_ad_text: { widget: 'wordCount', options: { maxWords: 320 } }
        FIELD_WIDGETS: {},
      },
    },
    ORGANIZATIONS: {
      ORGANIZATION_GROUP_FIELDS: {
        personal_info: {
          key: 'personal_info',
          name: 'Personal information',
          description: `Provide your personal information.
    This information is not public and will only be used for invoicing and other
    account related actions.`,
          fields: {
            org_base_salutation: 'salutation',
            org_base_firstname: 'firstName',
            org_base_lastname: 'lastName',
            field_org_base_phone: 'phone',
            field_org_base_position: 'position',
          },
        },
        company_info: {
          key: 'company_info',
          name: 'Company information',
          description: `Provide information about your company. This information is used publicly on your company profile
    page once you publish it.`,
          fields: {
            label: 'name',
            field_org_base_address: {
              name: 'address',
              fields: {
                countryCode: 'countryCode',
                addressLine1: 'addressLine1',
                addressLine2: 'addressLine2',
                addressLine3: 'addressLine3',
                administrativeArea: 'administrativeArea',
                locality: 'locality',
                postalCode: 'zip',
              },
            },
          },
        },
      },
    },
  },
  server: {},
};
